import { observer } from 'mobx-react-lite'
import {
  NoticeBanner,
  NoticeBannerAction,
  NoticeBannerCloseButton,
} from '@/features/shell/notice-banner/NoticeBanner'
import { useCallback, useState } from 'react'

interface CallCenterNoticeBannerContainerProps {
  onPress: () => void
}

export const CallCenterNoticeBannerContainer = observer(
  function CallCenterNoticeBannerContainer({
    onPress,
  }: CallCenterNoticeBannerContainerProps) {
    const [isBannerVisible, setIsBannerVisible] = useState(true)
    const closeAnnouncement = useCallback(() => setIsBannerVisible(false), [])

    return isBannerVisible ? (
      <NoticeBanner>
        <NoticeBannerAction onPress={onPress}>
          Call for assistance
        </NoticeBannerAction>

        <NoticeBannerCloseButton onPress={closeAnnouncement} />
      </NoticeBanner>
    ) : null
  },
)
